module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/cap-1-8235396717f6634c38c7789130d116f2.svg";